import React from 'react'
import ThreeScene from './ThreeScene'
import ThreeSceneWithHandles from "./ThreeSceneWithHandles";

function App() {
    return <ThreeScene />
}

export default App
